var SpriteSymbol = require("../../../../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../../../../node_modules/.pnpm/rspack-svg-sprite-loader@6.0.12/node_modules/rspack-svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "icon-sprite-tab-active-personal",
  "use": "icon-sprite-tab-active-personal-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-sprite-tab-active-personal\"><g transform=\"translate(7 5)\" fill=\"var(--theme-primary, #00BC70)\" fill-rule=\"evenodd\"><circle cx=\"17.5\" cy=\"10.5\" r=\"10.5\" /><path d=\"M0 38c0-11.046 7.611-20 17-20s17 8.954 17 20\" /></g></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol